import React from 'react'
import './style.scss'
import { Section } from '../ui'

export default function JavascriptHome() {
  return (
    <div className="sw-pad">
      <Section label={"Javascript"}>
      </Section>
    </div>
  )
}
